export const SEARCH_MAX_LENGTH = 50;

export const clampSearchInput = (value) => {
  if (value == null) return "";
  return String(value).replace(/^\s+/, "").slice(0, SEARCH_MAX_LENGTH);
};

export const normalizePastedSearchInput = (value) => {
  if (value == null) return "";
  const trimmed = String(value ?? "").trim();
  const mobileLike = /^[+\d\s-]+$/.test(trimmed) && /\d/.test(trimmed);
  const normalized = mobileLike ? trimmed.replace(/[^\d+]/g, "") : trimmed;
  return normalized.slice(0, SEARCH_MAX_LENGTH);
};
